import Startup from 'js/app/effects/transitions/Startup'
import Default from 'js/app/effects/transitions/Default'
import ToContact from 'js/app/effects/transitions/ToContact'

export default {
  'none --> none': new Startup().run,
  '* --> *': new Default().run,
  '* --> ContactHome': new ToContact().run,
}